import { render, staticRenderFns } from "./WorkAuctionsToken.vue?vue&type=template&id=1337a807&lang=pug&"
import script from "./WorkAuctionsToken.vue?vue&type=script&lang=js&"
export * from "./WorkAuctionsToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports